import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { EventCard } from "@/components/EventCard";
import { BookingDialog } from "@/components/BookingDialog";
import { api } from "@/lib/api";

export const SoireesDecouverte = () => {
  const [events, setEvents] = useState([]);
  const [booking, setBooking] = useState(null);
  useEffect(() => {
    api.events({ type: "soiree" }).then(setEvents).catch(() => {});
  }, []);
  if (events.length === 0) return null;
  return (
    <section id="soirees-decouverte" className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 lg:pb-32 scroll-mt-28" data-testid="soirees-decouverte">
      <Reveal className="max-w-2xl mb-10">
        <p className="eyebrow mb-6">Soirées découverte — géobiologie & radiesthésie</p>
        <h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight">Comprendre les bases et essayer soi-même, <em className="not-italic text-terra">en une soirée à l'atelier.</em></h2>
        <p className="text-fumee mt-4 leading-relaxed">Deux soirées d'initiation, sans prérequis : lire un lieu et manier les outils. Un premier pas concret avant, ou à la place, d'une harmonisation chez vous.</p>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-6">
        {events.map((e, i) => <EventCard key={e.id} event={e} index={i} onBook={setBooking} />)}
      </div>
      <BookingDialog event={booking} open={!!booking} onOpenChange={(v) => !v && setBooking(null)} />
    </section>
  );
};
